import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);
const apiBaseUrl = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:54765';

export default new Vuex.Store({
    state: {
        PensionsData: [],
        ChartFilter: [],
        AverageTotal: [],
        XaxisSelection: '',
        YaxisSelection: '',
        RaxisSelection: '',
        ColourSelection: '',
        BoxBool: false,
        uploadMessage: ''
    },
    getters: {
        getPensionsData: state => {
            return state.PensionsData;
        },
        getAverageTotal: state => {
            return state.AverageTotal;
        },
        getXaxisSelection: state => {
            return state.XaxisSelection;
        },
        getYaxisSelection: state => {
            return state.YaxisSelection;
        },
        getRaxisSelection: state => {
            return state.RaxisSelection;
        },
        getColourSelection: state => {
            return state.ColourSelection;
        },
        getChartFilter: state => {
            return state.ChartFilter;
        },
        getBoxBool: state => {
            return state.BoxBool;
        },
        getUploadMessage: state => {
            return state.uploadMessage;
        }
    },
    mutations: {
        updatePensionsData (state, responseData) {
            state.PensionsData = responseData;
        },
        updateAverageTotal (state, responseData) {
            state.AverageTotal = responseData;
        },
        updateXaxisSelection (state, updateData) {
            state.XaxisSelection = updateData;
        },
        updateYaxisSelection (state, updateData) {
            state.YaxisSelection = updateData;
        },
        updateRaxisSelection (state, updateData) {
            state.RaxisSelection = updateData;
        },
        updateColourSelection (state, updateData) {
            state.ColourSelection = updateData;
        },
        updateChartFilter (state, updateData) {
            state.ChartFilter = updateData;
        },
        updateBoxBool (state, updateData) {
            console.log(updateData);
            state.BoxBool = updateData;
        },
        updateUploadMessage (state, updateData) {
            state.uploadMessage = updateData;
        }
    },
    actions: {
        loadPensionsData: function ({commit}, fileName) {
            return new Promise((resolve, reject) => {
                axios.get(apiBaseUrl + '/getChartData?fileName=' + fileName).then((response) => {
                    commit('updatePensionsData', response.data);
                    resolve();
                });
            });
        },
        uploadFile: function ({commit}, formData) {
            return new Promise((resolve, reject) => {
                axios.post(apiBaseUrl + '/uploadFile', formData).then((response) => {
                    commit('updateUploadMessage', response.data);
                    resolve();
                });
            });
        },
        downloadFile: function ({commit}, fileName) {
            window.open(apiBaseUrl + '/downloadFile?fileName=' + fileName, '_self');
        }
    }
});



// WEBPACK FOOTER //
// ./src/store/index.js